import { render, staticRenderFns } from "./EventsChart.vue?vue&type=template&id=23197805&"
import script from "./EventsChart.vue?vue&type=script&lang=js&"
export * from "./EventsChart.vue?vue&type=script&lang=js&"
import style0 from "./EventsChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports